import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { AccountEditProps } from "./EditEmail";
export interface ModerationOption {
  title: string;
  value: string;
}

const EditPassword = ({ close }: AccountEditProps) => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [verifyPassword, setVerifyPassword] = useState("");

  const [isValidForm, setIsValidForm] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string | undefined }>({});

  const schema = Yup.object({
    password: Yup.string().required("Password is required").min(8, "Password must be at least 8 characters long"),
    confirmPassword: Yup.string()
      .required("Confirm Password is required")
      .oneOf([Yup.ref("password")], "Passwords must match"),
  });

  useEffect(() => {
    const validate = async (password: string, verifyPassword: string) => {
      try {
        await schema.validate({ password, verifyPassword }, { abortEarly: true });
        setIsValidForm(true);
      } catch (err) {
        setIsValidForm(false);
      }
    };
    validate(password, verifyPassword);
  }, [password, verifyPassword]);

  const onInputEvent = async (event: React.FocusEvent<HTMLInputElement>) => {
    const { name, value } = event.target;
    if (event.type === "focus") {
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return;
    }
    try {
      await schema.validateAt(name, { [name]: value });
      setErrors(prev => {
        const { [name]: _, ...rest } = prev;
        return rest;
      });
      return true;
    } catch (err) {
      let error = err as Yup.ValidationError;
      setErrors(prev => ({ ...prev, [name]: error.message }));
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className="p-6 bg-white rounded-lg shadow-lg w-80">
        <h2 className="mb-4 text-lg font-semibold">Change Password</h2>
        <div className="mb-5 flex flex-col space-y-[10px] w-full">
          <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Current password
          </label>
          <input
            type="password"
            name="currentPassword"
            id="currentpassword"
            className="w-full h-[36px] rounded-md border border-gray-300 px-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
            placeholder="Password"
            required
            value={currentPassword}
            onChange={e => {
              const val = e.target.value;
              setCurrentPassword(val);
            }}
            onBlur={onInputEvent}
            onFocus={onInputEvent}
          />
          {errors.currentPassword && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.currentPassword}</span>}
          <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            New password
          </label>
          <input
            type="password"
            name="password"
            id="password"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Password"
            value={password}
            required
            onChange={e => {
              const val = e.target.value;
              setPassword(val);
            }}
            onBlur={onInputEvent}
            onFocus={onInputEvent}
          />
          {errors.password && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.password}</span>}

          <label htmlFor="email" className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">
            Confirm password
          </label>
          <input
            type="password"
            name="confirmPassword"
            id="confirmpassword"
            className="bg-white border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
            placeholder="Confirm password"
            required
            value={verifyPassword}
            onBlur={onInputEvent}
            onFocus={onInputEvent}
            onChange={e => {
              const val = e.target.value;
              setVerifyPassword(val);
            }}
          />
          {errors.confirmPassword && <span className="block mb-2 text-sm text-red-600 dark:text-red-500">{errors.confirmPassword}</span>}
        </div>
        <div className="flex flex-col space-y-2">
          <button
            className="px-4 py-2 text-black bg-white border border-black rounded-md"
            onClick={e => {
              console.log("Action pressed");
              //onAction(contentId, action, moderationData.reason, moderationData.note);
            }}
            disabled={!isValidForm}
          >
            Update password
          </button>
          <button
            className="px-4 py-2 text-red-600 border border-black rounded-md"
            onClick={() => {
              close();
            }}
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default EditPassword;
